import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Alert from "@mui/material/Alert";
import { reportError } from "../features/firestoreStudio/release/services/errorReportingService";

function isDeveloperMode() {
  return process.env.NODE_ENV === "development" || localStorage.getItem("firestoreStudio.devMode") === "true";
}

export default class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorId: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    const reported = reportError({
      message: error?.message,
      stack: [error?.stack, errorInfo?.componentStack].filter(Boolean).join("\n"),
      source: "frontend",
      meta: { componentStack: errorInfo?.componentStack },
    });
    this.setState({ errorId: reported.errorId });
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorId: null });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const devMode = isDeveloperMode();

    return (
      <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", p: 3, bgcolor: "background.default" }}>
        <Paper variant="outlined" sx={{ p: 4, maxWidth: 560, width: "100%" }}>
          <Typography variant="h5" fontWeight={800} gutterBottom>
            Something went wrong
          </Typography>
          <Typography color="text.secondary" paragraph>
            An unexpected error occurred. Our team has been notified.
          </Typography>
          {this.state.errorId && (
            <Alert severity="info" sx={{ mb: 2 }}>
              Error ID: <strong>{this.state.errorId}</strong> — include this when contacting support.
            </Alert>
          )}
          {devMode && this.state.error && (
            <Typography
              component="pre"
              sx={{ fontSize: 11, bgcolor: "action.hover", p: 2, borderRadius: 1, overflow: "auto", maxHeight: 200, mb: 2 }}
            >
              {this.state.error.message}
              {"\n\n"}
              {this.state.error.stack}
            </Typography>
          )}
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button variant="contained" onClick={this.handleRetry}>Retry</Button>
            <Button variant="outlined" href="/admin/projects">Go to Studio</Button>
          </Box>
        </Paper>
      </Box>
    );
  }
}
